import React from "react";
import SC from "./style";

function AllProjectCircle({ data }) {
  const totalItems = data.length;
  const radius = 300; // Radius for feature placement
  const centerX = 350;
  const centerY = 300;
  const angleStep = (2 * Math.PI) / totalItems; // Distribute evenly in a full circle

  return (
    <SC.Container>
      <SC.Circle>
        <SC.CenterText>
          <h1 style={{ fontSize: "38px" }}>
            All-in-One Project Management Software
          </h1>
        </SC.CenterText>

        {data.map((feature, index) => {
          const angle = index * angleStep;
          const x = centerX + radius * Math.cos(angle);
          const y = centerY + radius * Math.sin(angle);
          const IconComponent = feature.icon;

          return (
            <SC.Feature key={index} x={x} y={y}>
              <SC.IconWrapper>
                {/* <IconComponent size={24} color="#1e3a8a" /> */}
              </SC.IconWrapper>
              <SC.Label>{feature.label}</SC.Label>
            </SC.Feature>
          );
        })}
      </SC.Circle>
    </SC.Container>
  );
}

export default AllProjectCircle;
